module.exports = __webpack_public_path__ + "img/Headhunter.7e4ec33d.svg";